/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingItemBundleCreateRequestV1Request,
  BillingItemBundleLineAddRequestV1Request,
  BillingItemBundleResponseV1,
  BillingV1BillingItemBundlesDestroyPathParameters,
  BillingV1BillingItemBundlesLinesCreatePathParameters,
  BillingV1BillingItemBundlesLinesDestroyPathParameters,
  BillingV1BillingItemBundlesLinesPartialUpdatePathParameters,
  BillingV1BillingItemBundlesListParams,
  BillingV1BillingItemBundlesPartialUpdatePathParameters,
  BillingV1BillingItemBundlesRetrievePathParameters,
  CursorPaginatedBillingItemBundleResponseV1,
  PatchedBillingItemBundleLineUpdateRequestV1Request,
  PatchedBillingItemBundleUpdateRequestV1Request
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingBillingItemBundleService {
  private readonly http = inject(HttpClient);
/**
 * Admin-only. Returns bundles ordered by `id` ascending. `?active=true` narrows to live bundles; `?active=false` to retired; absent = all.
 * @summary List billing item bundles (admin-only, cursor-paginated).
 */
 billingV1BillingItemBundlesList<TData = CursorPaginatedBillingItemBundleResponseV1>(params?: BillingV1BillingItemBundlesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemBundlesList<TData = CursorPaginatedBillingItemBundleResponseV1>(params?: BillingV1BillingItemBundlesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemBundlesList<TData = CursorPaginatedBillingItemBundleResponseV1>(params?: BillingV1BillingItemBundlesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemBundlesList<TData = CursorPaginatedBillingItemBundleResponseV1>(
    params?: BillingV1BillingItemBundlesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/billing_item_bundles/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/billing_item_bundles/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/billing_item_bundles/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. Creates one BillingItemBundle. `lines[]` is optional: when sent, every line is created in the same transaction, and an unknown `billing_item` returns 404 with nothing created. Lines can also be managed one at a time via `bundles/{identity}/lines/`. A duplicate `name` returns 409.
 * @summary Create a bundle.
 */
 billingV1BillingItemBundlesCreate<TData = BillingItemBundleResponseV1>(billingItemBundleCreateRequestV1Request: BillingItemBundleCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemBundlesCreate<TData = BillingItemBundleResponseV1>(billingItemBundleCreateRequestV1Request: BillingItemBundleCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemBundlesCreate<TData = BillingItemBundleResponseV1>(billingItemBundleCreateRequestV1Request: BillingItemBundleCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemBundlesCreate<TData = BillingItemBundleResponseV1>(
    billingItemBundleCreateRequestV1Request: BillingItemBundleCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/billing_item_bundles/`,
      billingItemBundleCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/billing_item_bundles/`,
      billingItemBundleCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/billing_item_bundles/`,
      billingItemBundleCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Returns the bundle with `lines[]` expanded (each line carries a light `billing_item` reference).
 * @summary Retrieve one bundle with expanded lines.
 */
 billingV1BillingItemBundlesRetrieve<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemBundlesRetrieve<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemBundlesRetrieve<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemBundlesRetrieve<TData = BillingItemBundleResponseV1>(
    { identity }: BillingV1BillingItemBundlesRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/billing_item_bundles/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/billing_item_bundles/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v1/billing/billing_item_bundles/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only PATCH. Header fields are preserve-on-omit. `lines[]`, when sent, replaces every line of the bundle in the same transaction (an unknown `billing_item` returns 404 with nothing changed); omitted, the lines stay. Lines can also be managed one at a time via `bundles/{identity}/lines/`. Rename collision returns 409.
 * @summary Partial update of bundle header (name / description / active).
 */
 billingV1BillingItemBundlesPartialUpdate<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesPartialUpdatePathParameters,
    patchedBillingItemBundleUpdateRequestV1Request?: PatchedBillingItemBundleUpdateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemBundlesPartialUpdate<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesPartialUpdatePathParameters,
    patchedBillingItemBundleUpdateRequestV1Request?: PatchedBillingItemBundleUpdateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemBundlesPartialUpdate<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesPartialUpdatePathParameters,
    patchedBillingItemBundleUpdateRequestV1Request?: PatchedBillingItemBundleUpdateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemBundlesPartialUpdate<TData = BillingItemBundleResponseV1>(
    { identity }: BillingV1BillingItemBundlesPartialUpdatePathParameters,
    patchedBillingItemBundleUpdateRequestV1Request?: PatchedBillingItemBundleUpdateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/billing_item_bundles/${identity}/`,
      patchedBillingItemBundleUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/billing_item_bundles/${identity}/`,
      patchedBillingItemBundleUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/billing_item_bundles/${identity}/`,
      patchedBillingItemBundleUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Cascade removes the child `BillingItemBundleLine` rows; `BillingItem` rows are NOT touched. A charge for work is unaffected — it holds its own snapshotted lines and never references the bundle.
 * @summary Hard-delete the bundle + cascade its lines.
 */
 billingV1BillingItemBundlesDestroy<TData = void>(pathParams: BillingV1BillingItemBundlesDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemBundlesDestroy<TData = void>(pathParams: BillingV1BillingItemBundlesDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemBundlesDestroy<TData = void>(pathParams: BillingV1BillingItemBundlesDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemBundlesDestroy<TData = void>(
    { identity }: BillingV1BillingItemBundlesDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/billing_item_bundles/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/billing_item_bundles/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/billing_item_bundles/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Appends one BillingItemBundleLine to the bundle. `billing_item` is the identity string of an existing BillingItem (M-api-2). `default_quantity` defaults to 1. Returns the bundle refreshed with the new line.
 * @summary Add one line to a bundle.
 */
 billingV1BillingItemBundlesLinesCreate<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesLinesCreatePathParameters,
    billingItemBundleLineAddRequestV1Request: BillingItemBundleLineAddRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemBundlesLinesCreate<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesLinesCreatePathParameters,
    billingItemBundleLineAddRequestV1Request: BillingItemBundleLineAddRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemBundlesLinesCreate<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesLinesCreatePathParameters,
    billingItemBundleLineAddRequestV1Request: BillingItemBundleLineAddRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemBundlesLinesCreate<TData = BillingItemBundleResponseV1>(
    { identity }: BillingV1BillingItemBundlesLinesCreatePathParameters,
    billingItemBundleLineAddRequestV1Request: BillingItemBundleLineAddRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/billing_item_bundles/${identity}/lines/`,
      billingItemBundleLineAddRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/billing_item_bundles/${identity}/lines/`,
      billingItemBundleLineAddRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/billing_item_bundles/${identity}/lines/`,
      billingItemBundleLineAddRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only PATCH. Only `default_quantity` is editable. `billing_item` is immutable — to change the item, DELETE + POST. `default_quantity` is required in the body (the only editable field; documented as RPC-style action rather than preserve-on-omit). Returns the bundle refreshed.
 * @summary Change default_quantity of one line.
 */
 billingV1BillingItemBundlesLinesPartialUpdate<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesLinesPartialUpdatePathParameters,
    patchedBillingItemBundleLineUpdateRequestV1Request?: PatchedBillingItemBundleLineUpdateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemBundlesLinesPartialUpdate<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesLinesPartialUpdatePathParameters,
    patchedBillingItemBundleLineUpdateRequestV1Request?: PatchedBillingItemBundleLineUpdateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemBundlesLinesPartialUpdate<TData = BillingItemBundleResponseV1>(pathParams: BillingV1BillingItemBundlesLinesPartialUpdatePathParameters,
    patchedBillingItemBundleLineUpdateRequestV1Request?: PatchedBillingItemBundleLineUpdateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemBundlesLinesPartialUpdate<TData = BillingItemBundleResponseV1>(
    { identity, lineIdentity }: BillingV1BillingItemBundlesLinesPartialUpdatePathParameters,
    patchedBillingItemBundleLineUpdateRequestV1Request?: PatchedBillingItemBundleLineUpdateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/billing_item_bundles/${identity}/lines/${lineIdentity}/`,
      patchedBillingItemBundleLineUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/billing_item_bundles/${identity}/lines/${lineIdentity}/`,
      patchedBillingItemBundleLineUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/billing_item_bundles/${identity}/lines/${lineIdentity}/`,
      patchedBillingItemBundleLineUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Removes one BillingItemBundleLine; the `BillingItem` is PROTECTed and untouched.
 * @summary Remove one line from a bundle.
 */
 billingV1BillingItemBundlesLinesDestroy<TData = void>(pathParams: BillingV1BillingItemBundlesLinesDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1BillingItemBundlesLinesDestroy<TData = void>(pathParams: BillingV1BillingItemBundlesLinesDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1BillingItemBundlesLinesDestroy<TData = void>(pathParams: BillingV1BillingItemBundlesLinesDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1BillingItemBundlesLinesDestroy<TData = void>(
    { identity, lineIdentity }: BillingV1BillingItemBundlesLinesDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/billing_item_bundles/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/billing_item_bundles/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/billing_item_bundles/${identity}/lines/${lineIdentity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1BillingItemBundlesListClientResult = NonNullable<CursorPaginatedBillingItemBundleResponseV1>
export type BillingV1BillingItemBundlesCreateClientResult = NonNullable<BillingItemBundleResponseV1>
export type BillingV1BillingItemBundlesRetrieveClientResult = NonNullable<BillingItemBundleResponseV1>
export type BillingV1BillingItemBundlesPartialUpdateClientResult = NonNullable<BillingItemBundleResponseV1>
export type BillingV1BillingItemBundlesDestroyClientResult = NonNullable<void>
export type BillingV1BillingItemBundlesLinesCreateClientResult = NonNullable<BillingItemBundleResponseV1>
export type BillingV1BillingItemBundlesLinesPartialUpdateClientResult = NonNullable<BillingItemBundleResponseV1>
export type BillingV1BillingItemBundlesLinesDestroyClientResult = NonNullable<void>
